"use client";
import * as React from "react";
const SvgArrowDownwardRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.98 1.03V12.5L1.97 7.48c-.4-.4-1.06-.4-1.46 0S.1 8.53.5 8.93l6.77 6.77c.4.4 1.04.4 1.44 0l6.77-6.77a1.02 1.02 0 1 0-1.45-1.44l-5 5V1.04A1.03 1.03 0 0 0 8 0a1.03 1.03 0 0 0-1.03 1.03Z" }));
export {
  SvgArrowDownwardRound as default
};
